import React, { useEffect } from 'react'
import { withAppContext } from 'src/store/initAppContext';
import styled, { withTheme } from 'styled-components';
import { LazyLoadImage } from "react-lazy-load-image-component";
import config from "src/config/config";
import PlaceholderImage from 'src/components/Placeholder';
import { theme } from 'styled-tools';

function BigBashBigCashPromoFomo(props) {
    const { app: {
        brandId
    }, theme } = props;

    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])

    const domain = (brandId == 31 || brandId == 32) ? "Yolo247" : (brandId == 39 || brandId == 40) ? "FOMO7" : 'IW247';

    return (
        <>
            <InformationWrapper>
                <TitleText>
                    <FomoHeading>
                        <h2>Risk Free Bet!</h2>
                        <UnderLine></UnderLine>
                    </FomoHeading>
                    <p>This Big Bash, play like a cricket superstar only on <strong>{domain}!</strong></p>
                    <p>We present the offer of the year for all crazy cricket fans! Lost the last match? No worries, <strong>{domain}</strong> gives you a chance to play RISK FREE!</p>
                </TitleText>
                <CashbackHeading>
                    <Divider></Divider>
                    <h3>Experience the thrill of daily bonus – 100% Loss back</h3>
                    <UnderLine></UnderLine>
                </CashbackHeading>
                <FomoBodyWrapper>
                    <RightWrapper>
                        <LazyLoadImage
                            src={`${config.imageV3Host}/static/cashsite/${theme.image.BigBashBigCashTeamImage}`}
                            alt="bigBashBigCashteams"
                            effect="none"
                            placeholder={<PlaceholderImage />}
                        />
                    </RightWrapper>
                    <LeftWrapper>
                        <RoContent>
                            <TextWrapper>
                                <p><span className='labelHeaderFomo'>Deposit : </span>Deposit in your {domain} account. Keep it loaded and ready for action throughout Dec 24 & Jan 25.</p>
                            </TextWrapper>
                            <TextWrapper>
                                <p><span className='labelHeaderFomo'>Play : </span>Dive into the excitement of Cricket matches by placing your bets on our cutting-edge exchange platform
                                </p>
                            </TextWrapper>
                            <TextWrapper>
                                <p><span className='labelHeaderFomo'>Claim your prize : </span> For cumulative losses of the day, we'll reward you with an 100% additional loss back bonus the very next day</p>
                            </TextWrapper>
                        </RoContent>
                    </LeftWrapper>
                </FomoBodyWrapper>
                <Termsandconditions>
                    <TermsandconditionsHeading>
                        <h1>Terms & Conditions</h1>
                    </TermsandconditionsHeading>
                    <UnderLine></UnderLine>
                    <TermsandconditionsBody>
                        <ul>
                            <li>The loss back bonus will be applied to ‘Big Bash bets - for the day’, placed during the match.</li>
                            <li>The bonus amount for each qualifying bet will be capped at INR 50.</li>
                            <li>The bonus will be credited to your <strong>{domain}</strong> account the next day.</li>
                            <li>Bonus will be expired within 24-48 hours.</li>
                            <li>There is no limit to the number of bets you can place to earn the 100% Daily bonus, ‘for the day’.</li>
                            <li>The daily bonus can be used to place future bets on <strong>{domain}</strong> as this bonus cannot be withdrawn. Only winnings can be withdrawn.</li>
                            <li>This promotion is valid only for Big Bash.</li>
                            <li><strong>{domain}</strong> reserves the right to disqualify any user found engaging in fraudulent activities.</li>
                            <li><strong>{domain}</strong> General Terms & Conditions apply.</li>
                        </ul>
                    </TermsandconditionsBody>
                </Termsandconditions>
            </InformationWrapper>
        </>
    )
}



export default withTheme(withAppContext(BigBashBigCashPromoFomo));

const InformationWrapper = styled.div`
    width: 98%;
    height: auto;
    padding: 3rem 3rem 8rem 3rem;
    border-radius: 1px;
    background: rgba(111, 111, 111, 0.5);
    margin: 0em 1.2em 0 1.2em;
    border: 1px solid #E5B358;
    border-radius: 0 0 20px 20px;
    border-top-color: transparent;
    backdrop-filter: brightness(0.5);    
    display: flex;
    flex-direction: column;
    background: url(${config.imageV3Host}/static/cashsite/${theme("image.BigBashBigCashBackground")});
    background-position: top;
    background-size: cover;
    background-repeat: no-repeat;
`;

const TitleText = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    padding: 0 7rem 4rem 7rem;

    h1 {
        color: #FFDE00;
        text-align: center;
        font-size: 20px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
        text-transform: capitalize;
        padding-bottom: 1rem;
    }

    p {
        margin: 0;
        padding: 0;
        color: #FFF;
        font-size: 16px;
        font-style: normal;
        text-align: center;
        font-weight: 500;
        line-height: 160.3%;
        text-transform: capitalize;
    }
`;

const Divider = styled.div`
    height: 2px;
    width: 100%;
    background: radial-gradient(#1182C1 0%, #00000000 50%);
`;

const FomoHeading = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    padding: 0 0 2rem 0;

    h2, h3 {
        text-align: center;
        font-size: 25px;
        font-style: normal;
        font-weight: 600;
        line-height: 107.7%; /* 26.925px */
        letter-spacing: 1.25px;
        background: linear-gradient(180deg, #FED546 18.06%, #FE7C23 115.57%);
        background-clip: text;
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        margin: 0;
        padding: 1.5rem 0;
    }

    h3 {
        padding-top: 4rem;
    }
`;

const CashbackHeading = styled(FomoHeading)`
    background: radial-gradient(37.24% 47.13% at 50% 0%, #051829 0%, rgba(1, 4, 6, 0.00) 100%);
    backdrop-filter: blur(6.849999904632568px);
`;

const BodyWrapper = styled.div`
    display: flex;
    justify-content: space-evenly;
    align-items: flex-start;
    width: 100%;
    gap: 1rem;
    padding: 0 5rem;
`;

const FomoBodyWrapper = styled(BodyWrapper)`
    align-items: center;
    padding-top: 1rem;

    h1 {
        background: linear-gradient(180deg, #FED546 18.06%, #FE7C23 91.67%);
        background-clip: text;
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        margin-bottom: 0.25rem !important;
    }

    .fomoBullet {
        color: #FEBA3B;
    }
`;

const LeftWrapper = styled.div`
    display: flex;
    flex-direction: row;
    /* width: 45%; */
    width: 50%;
`;

const RightWrapper = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    position: relative;
    align-self: center;

    img {
        width: 35rem;
    }
`;

const RoContent = styled.div`
    display: flex;
    flex-direction: column;
    gap: 1rem;
    width: 100%;

    h1 {
        margin: 0 0 1.5rem 0;
        color: #FFDE00;
        font-size: 20px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
        text-transform: capitalize;
    }
`;

const TextWrapper = styled.div`
    display: flex;
    text-transform: capitalize;

    .labelHeader {
        color: #FFDE00;
        font-weight: 700;
    }

    .labelHeaderFomo {
        color: #FEBA3B;
        font-weight: 700;
    }

    p {
        margin: 0;
        color: #FFF;
        font-size: 16px;
        font-style: normal;
        font-weight: 500;
        line-height: 170.3%; /* 19.248px */
        text-align: left;
    }
`;


const UnderLine = styled.div`
    height: 2px;
    width: 184px;
    background: radial-gradient(#FFF 0%, rgba(153, 153, 153, 0.00) 80%);
`;

const Termsandconditions = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    border-radius: 30px;
    width: 80%;
    height: auto;
    margin: 4rem 10% 3rem 10%;
    padding: 5rem 3rem;
    position: relative;
    background: linear-gradient(#020405, rgba(0, 0, 0, 0.935), #020405);
    background-clip: padding-box;
    border: 2px solid transparent;

    ::after {
        position: absolute;
        top: -2px; bottom: -2px;
        left: -2px; right: -2px;
        background: linear-gradient(90deg, #53C1FF, black, #53C1FF, black, #53C1FF);
        content: '';
        z-index: -1;
        border-radius: 30px;
    }
`;

const TermsandconditionsHeading = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;    
    padding-bottom: 2rem;

    h1 {
        margin: 0;
        padding: 0;
        text-align: center;
        font-size: 25px;
        font-style: normal;
        font-weight: 600;
        line-height: normal;
        letter-spacing: 1.25px;
        background: linear-gradient(180deg, #FED546 18.06%, #FE7C23 91.67%);
        background-clip: text;
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
    }
`;

const TermsandconditionsBody = styled.div`
    ul {
        display: flex;
        flex-direction: column;
        justify-content: center;
        gap: 1rem;
        padding-top: 1rem;
    }

    li {
        color: #FFF;
        font-size: 16px;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
        text-transform: capitalize;
    }
`;